import { useEffect } from 'react';

// Calls `onEscape` whenever the Escape key is pressed while mounted.
export function useEscapeKey(onEscape) {
    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onEscape(); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onEscape]);
}
